// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_GIANTS = [{
  id: 'giants_cow',
  factionId: FACTIONS.GIANTS,
  name: 'горный Пастух',
  priceNumens: 7000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.DARK_GREEN,
  ]
}, {
  id: 'giants_ice',
  factionId: FACTIONS.GIANTS,
  name: 'Гнев льдов',
  priceNumens: 48000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'giants_mountain',
  factionId: FACTIONS.GIANTS,
  name: 'Великан-гора',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: 'giants_gold_legacy',
  factionId: FACTIONS.GIANTS,
  name: 'Костяной вождь',
  priceNumens: 130000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'giants_ruby_legacy',
  factionId: FACTIONS.GIANTS,
  name: 'Сокрушитель городов',
  priceCrystals: 450,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
